module.exports = __webpack_public_path__ + "static/img/14010204.35002dc3.png";